import { render, staticRenderFns } from "./ai-config.vue?vue&type=template&id=38f84373&scoped=true"
import script from "./ai-config.vue?vue&type=script&lang=js"
export * from "./ai-config.vue?vue&type=script&lang=js"
import style0 from "./ai-config.vue?vue&type=style&index=0&id=38f84373&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f84373",
  null
  
)

export default component.exports